import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'adp-details-table',
  templateUrl: './details-table.component.html',
  styleUrls: ['./details-table.component.css']
})
export class DetailsTableComponent implements OnInit {

  public alcanceTotal: number;
  public valorTotal: number;

  @Input() public data: any;

  ngOnInit(): void {
    this.alcanceTotal = this.data.alcanceTotal;
    this.valorTotal = this.data.valorizadoTotal;
  }

}
